import {
  FormBody,
  FormFieldsContainer,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../../../../../Form'
import { RentalPortalListingDescriptionField } from '../../../../../../../RentalPortalListing'
import { useRentalPortalProfileBlockFormActions } from '../../../../../../RentalPortal.hooks'

import * as styles from '../../RentalPortalListingProfileDescriptionWidget.module.css'

function RentalPortalListingProfileDescriptionWidgetFormFields({
  isCloseConfirm,
  notifications,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { actionsProps } = useRentalPortalProfileBlockFormActions({
    isCloseConfirm,
    onCancel,
  })

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  return (
    <FormBody actionsProps={actionsProps} className={styles.formBody}>
      <FormInlineNotifications notifications={notifications} />
      <FormFieldsContainer className={styles.fields}>
        <RentalPortalListingDescriptionField />
      </FormFieldsContainer>
    </FormBody>
  )
}

export default RentalPortalListingProfileDescriptionWidgetFormFields
